import React from 'react';
import './HomeLearn.css';


const Homelearn = () => {
  const badges = [
    { id: 1, label: 'AI', position: 'HomeLearn_badge--topRight' },
    { id: 2, label: 'DRONE', position: 'HomeLearn_badge--midRight' },
    { id: 3, label: 'ML', position: 'HomeLearn_badge--topLeft' },
    { id: 4, label: 'LMS', position: 'HomeLearn_badge--bottomLeft' },
  ];

  return (
  <>
  
    <div className="HomeLearn_wrapper">
      <div className="HomeLearn_imageBlock">
       <div className="HomeLearn_shapeSquare"></div>
        <div className="HomeLearn_imageFrame">
          <img
            src="https://contriver.co.in/wp-content/uploads/2022/03/Happy-Indian-Girl-College-Student-Pointing-Transparent-Image.png"
            alt="Learner"
            className="HomeLearn_image"
          />
        </div>
        {badges.map((badge) => (
          <div
            key={badge.id}
            className={`HomeLearn_badge ${badge.position}`}
          >
            {badge.label}
          </div>
        ))}
      </div>

      <div className="HomeLearn_content">
  
           <h1 className="HomeLearn_heading">
          Leading Platform for Learning in Native Languages.
        </h1>
 
        
        <p className="HomeLearn_description">
          Your platform, backed by trusted institutions, is a top tech-driven
          learning platform for regional and global languages. With a
          growing community of learners worldwide, it offers personalized
          online learning, upskilling, and job opportunities.
        </p>

       
      </div>
    </div>

  </>
  )
}

export default Homelearn